import React from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';

export default function ForgotPassword(props) {
    const [values, setValues] = React.useState({
        email: '',
      });
    
    const handleChange = (property) => (event) => {
        let value = event.target.value
        let id = event.target.id;
        singleErrorCheck(id, value);
        setValues({ ...values, [property]: value });
    };

    let errorStyle = (id, property, style) => {document.getElementById(`${id}`).style[property] = style}

    let errorTarget = (id, value) => {
        let errors = false;
        // let errorStyle = (style) => {document.getElementById(`${id}-container`).style.borderBottom = style}
        if(value.length < 1){
          errorStyle(`${id}-container`, 'border', '1px solid #ef4b4b')
          errors = true;
        } else if (id === 'email') {
          if(!emailValidation(value)) {
            errorStyle(`${id}-container`, 'border', '1px solid #5e76e8')
            // errorStyle('3px solid #5e76e8')
            errors = true;
          } else {
            errorStyle(`${id}-container`, 'border', '')
            // errorStyle('');
          }
        } else {
          errorStyle(`${id}-container`, 'border', '')
          // errorStyle('');
        }
        return errors;
    }

    const singleErrorCheck = (target, value) => {
        errorTarget(target, value);
    }
    
    const emailValidation = (string) => {
        let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        
        if(string.match(mailFormat)){
            return true;
        } else {
            return false;
        }
    }

    const [codeSent, setCodeSent] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [success, setSuccess] = React.useState(false);
    const sendRequest = () => {
        let tok =  btoa(`${props.unicycle}:${props.pencil}`);
        if(!emailValidation(values.email)) {return}
        let data = JSON.stringify({
            "orgId": props.orgId,
            "email": values.email,
        })

        axios.post('https://api.churchpad.com/p/forgotpassword/', data, {
            headers: { 
                'Authorization' : `Basic ${tok}`,
                'Content-Type': 'application/json',
            },
        }).then(res => {
            
            if(res.data.responseCode === '00') {
                setCodeSent(res.data.responseMessage);
                setSuccess(true);
            } else {
                setSuccess(false);
                setError(res.data.responseMessage);
            }
        }).catch(err => {
            console.log(err);
        })
    }
    return (
        <main className="authentication signup">
            <header>
                <span className="icon" style={{backgroundColor: props.colors.secondary}}>
                    <i className="las la-question"></i>
                </span>
                <h3>Forgot Password?</h3>
                <p>Enter your email and we'll send you a link to reset it.</p>
            </header>
            {codeSent ? <div className="center container forgot-message">
                <h4>{codeSent}</h4>
            </div> : <form className="col s12">
                <div className="row get-email">
                    <div className="input-field col s12 userCardNumber" id="email-container">
                        <input id="email" type="text" className="validate" onChange={handleChange('email')} value={values.email}/>
                        <label htmlFor="email">Email</label>
                    </div>
                </div>
            </form>}
            <div className="extraBtn">
                <Link to={'/cp/signin'}>
                    <button className="back-to-login"><h4><span><i className="las la-angle-left"></i></span> Back to login</h4> </button>
                </Link>
            </div>

            {success ? null : <div className="submit">
                <button className="signIn-button submit-btn waves-effect" style={{backgroundColor: props.colors.secondary}} onClick={sendRequest}> <h4>Send Request</h4> </button>
                <br/>
                <br/>
                <h4 className="red-text center">{error}</h4>
            </div>}
        </main>
    )
}
